<template>
  <v-card dark class="black" flat tile>
    <v-toolbar persistent class="transparent py-3" flat>
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.smAndDown"
        @click="$store.commit('navDrawerToggle')"
      ></v-app-bar-nav-icon>
      <v-spacer v-if="$vuetify.breakpoint.smAndDown"></v-spacer>
      <v-btn @click="$router.push('/')" text>
        <v-toolbar-title class="font-weight-black text-uppercase">
          Vira Designs
        </v-toolbar-title>
      </v-btn>
      <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>

      <v-btn
        text
        @click="$router.push('/about')"
        v-if="$vuetify.breakpoint.mdAndUp"
        >About</v-btn
      >
      <v-btn
        text
        @click="$router.push('/work')"
        v-if="$vuetify.breakpoint.mdAndUp"
        >Works</v-btn
      >
      <v-btn
        text
        @click="$router.push('/contact')"
        v-if="$vuetify.breakpoint.mdAndUp"
        >Contact</v-btn
      >
    </v-toolbar>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
